import { render } from "./Navgater.vue?vue&type=template&id=1cad8385&scoped=true&ts=true"
import script from "./Navgater.vue?vue&type=script&lang=ts"
export * from "./Navgater.vue?vue&type=script&lang=ts"

import "./Navgater.vue?vue&type=style&index=0&id=1cad8385&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cad8385"]])

export default __exports__